module.exports = __webpack_public_path__ + "assets/img/left2-fc0da608.png";